import CachedIcon from "@mui/icons-material/Cached";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Box,
  Breadcrumbs,
  Card,
  TextField,
  Button,
  MenuItem,
  Link,
  Paper,
  Stack,
  TableContainer,
  IconButton,
  Typography,
} from "@mui/material";
import Chip from "@mui/material/Chip";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import LoadingUI from "../../comman/LoadingUI";
import NoDataFound from "../../comman/NoDataFound";
import Appbar from "../../components/Appbar";
import DrawerUI from "../../components/Drawer";
import Body from "../../layout/Body";
import { userDetailAction } from "../../redux/toolkit/users/userDetail";
import { publisherUserAction } from "../../redux/toolkit/publisherUser/publisherUser";
import { useStyles } from "../../theme/theme";
import { Link as LinkRRD } from "react-router-dom";
// import moment from 'moment'
import { dateFormatStartFun } from "../../helper/dateConverter";
import { getPublisherAction } from "../../redux/toolkit/publisher/getPublisher";
import { singlePublisherUserAction } from "../../redux/toolkit/users/parternUsers";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import moment from "moment-timezone";
import SnackBarUI from "../../comman/SnackBarUI";
import { useNavigate } from "react-router-dom";
import BlockUserFromPartner from "./BlockUserFromPartner";
import { userWidthdrawPauseAction } from "../../redux/toolkit/publisherUser/userWidthdrawPause";
import { getAllPartnerActionNoLimit } from "../../redux/toolkit/partner/getAllPartnerNoLimit";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={<NavigateNextIcon sx={{ color: "#fff" }} fontSize="small" />}
      aria-label="breadcrumb"
    >
      <Link underline="hover" sx={{ color: "#000" }} color="inherit" href="/">
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#000" }}
        color="inherit"
        href="/publisher"
      >
        Publisher
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#000" }}
        color="inherit"
        href="/publisher-user"
      >
        Publisher Users
      </Link>
    </Breadcrumbs>
    <Typography variant="h5">Publisher Users</Typography>
  </Stack>
);

const PublisherUser = () => {
  const dispatch = useDispatch();
  // const navigateLocation = useLocation();

  const navigate = useNavigate();

  const userDetail = useSelector((state) => state.publisherUser);
  const {
    data: userDetailsData,
    loading: usersDetailsLoading,
    totalCount,
    status,
    message,
  } = userDetail;

  const [pageSize, setPageSize] = useState(25);
  const classes = useStyles();
  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });

  // const [blockUser, setBlockUser] = useState(false);
  // const [userData, setUserData] = useState({});

  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });

  const getPublisherSelector = useSelector((state) => state.getPublisher);
  const { data: publiserData } = getPublisherSelector;

  const [snack, setSnack] = useState(false);
  const [snack1, setSnack1] = useState(false);
  const widthdrawPause = useSelector(
    (state) => state.userWidthdrawPauseDetails
  );
  const { status: widthdrawPauseStatus, message: widthdrawPauseMsg } =
    widthdrawPause;

  const handleWidthdrawStatus = async (data, status) => {
    let updateStats = await dispatch(
      userWidthdrawPauseAction({
        p_user_id: data?.p_user_id,
        publisher_id: data?.publisher_id,
        user_id: data?.user_id,
        is_widthDraw_pause: status,
      })
    );

    if (updateStats?.payload?.status === 200) {
      setTimeout(() => {
        dispatch(
          publisherUserAction({
            page: pageState.page,
            limit: pageState.pageSize,
          })
        );
        setSnack(true);
      }, 3000);
    }

    setSnack1(true);
  };

  const missionDetailsColumn = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      minWidth: 50,
      headerClassName: "super-app-theme--header",
      renderCell: (index) => index?.api?.getRowIndex(index.row._id) + 1,
    },
    {
      field: "p_user_id",
      headerName: "P_User_ID",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          // <Typography>{params?.row?._id}</Typography>
          // <LinkRRD to={`/user-transaction?${params?.row?.p_user_id}`}>
          //   <Typography color="primary">{params?.row?.p_user_id}</Typography>
          // </LinkRRD>

           <Box
        sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        <LinkRRD to={`/user-transaction?${params?.row?.p_user_id}`}>
          <Typography color="primary" noWrap>
            {params?.row?.p_user_id}
          </Typography>
        </LinkRRD>
      </Box>
        );
      },
    },
    {
      field: "publisher_id",
      headerName: "Publisher name",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return params.row?.publisher_details?.name
          ? params.row?.publisher_details?.name
          : "---";
      },
    },

    {
      field: "earning",
      headerName: "Earning ($)",
      flex: 1,
      minWidth: 150,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return params.row.earnings
          ? Number(params.row.earnings).toFixed(4)
          : "---";
      },
    },

    {
      field: "raw_earnings",
      headerName: "Available Coins",
      flex: 1,
      minWidth: 150,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return params.row.raw_earnings
          ? (
              Number(params.row.raw_earnings) -
              Number(params.row.withdrawal_amount || 0)
            ).toFixed(4)
          : "---";
      },
    },

    {
      field: "withdrawal_amount",
      headerName: "Withdraw Coins",
      flex: 1,
      minWidth: 150,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return params.row.withdrawal_amount
          ? Number(params.row.withdrawal_amount).toFixed(4)
          : "---";
      },
    },

    {
      field: "user_id",
      headerName: "User ID",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      // renderCell: (params) => {
      //     <LinkRRD to={`/user-detail?${params?.row?.user_id}`}>
      //         <Typography color='primary'>{params?.row?.user_id}</Typography>
      //     </LinkRRD>
      // }
      renderCell: (params) => {
        return (
          <LinkRRD to={`/user-detail?${params?.row?.user_id}`}>
            <Typography color="primary">{params?.row?.user_id}</Typography>
          </LinkRRD>
        );
      },
    },

    {
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },

    // {
    //   field: "BlackListPartners",
    //   headerName: "BlackListPartners",
    //   flex: 1,
    //   minWidth: 170,
    //   headerClassName: "super-app-theme--header",
    //   renderCell: (params) => {
    //     return (
    //       <>
    //         {params.row?.blackListedPartners?.length > 0 ? (
    //           <Button
    //             variant="contained"
    //             onClick={() =>
    //               navigate(`/blacklist-partner`, { state: params.row })
    //             }
    //           >
    //             BlackListPartner
    //           </Button>
    //         ) : (
    //           "---"
    //         )}
    //       </>
    //     );
    //   },
    // },

    // {
    //   field: "block_user",
    //   headerName: "Block User From Partner",
    //   flex: 1,
    //   minWidth: 200,
    //   headerClassName: "super-app-theme--header",
    //   sortable: false,
    //   filterable: false,
    //   renderCell: (params) => {
    //     return (
    //       <Button
    //         variant="contained"
    //         color="secondary"
    //         onClick={() => {
    //           setBlockUser(true);
    //           setUserData(params.row);
    //           // console.log("Clicked row ID:", params.row._id);
    //         }}
    //       >
    //         Block User
    //       </Button>
    //     );
    //   },
    // },

    {
      field: "widthdraw_pause",
      headerName: "User Withdraw Pause",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const isPaused = params?.row?.is_widthDraw_pause;

        return (
          <>
            {isPaused ? (
              <Chip
                label="Unblock Withdraw"
                color="primary"
                onClick={() => handleWidthdrawStatus(params.row, false)}
              />
            ) : (
              <Chip
                label="Block Withdraw"
                color="error"
                onClick={() => handleWidthdrawStatus(params.row, true)}
              />
            )}
          </>
        );
      },
    },

    // {
    //   field: "widthdraw_transaction",
    //   headerName: "Widthdraw Transaction",
    //   flex: 1,
    //   minWidth: 200,
    //   headerClassName: "super-app-theme--header",
    //   renderCell: (params) => {
    //     return (
    //       <LinkRRD to={`/user-widthdraw-transaction?${params?.row?.p_user_id}`}>
    //         <Typography color="primary">
    //           <Chip label="Widthdraw Transaction" color="primary" />
    //         </Typography>
    //       </LinkRRD>
    //     );
    //   },
    // },

    {
      field: "created_at",
      headerName: "Created At",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      // renderCell: (params) => {
      //     return (
      //         moment(params?.row?.created_at).local().format("DD-MM-YYYY hh:mm:ss A")
      //     )
      // },
      renderCell: (params) => {
        return moment(params?.row?.created_at)
          .tz("Asia/Kolkata") // Force conversion to IST
          .format("DD-MM-YYYY hh:mm:ss A");
      },
    },
  ];

  const dateWiseUser = async () => {
    let updateStats = await dispatch(
      publisherUserAction({
        startDate: dateFormatStartFun(date?.startDate),
        endDate: dateFormatStartFun(date?.endDate),
        page: pageState.page,
        limit: pageState.pageSize,
        publisher_id: publisher?._id ? publisher?._id : null,
        userId: userId ? userId : null,
      })
    );

    setSnack(true);
  };

  const [publisher, setPublisher] = useState(null);
  const [userId, setUserId] = useState("");

  console.log("publisher ==================.", publisher);

  const searchHandler = () => {
    dispatch(
      publisherUserAction({
        userId: userId,
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: date?.startDate ? dateFormatStartFun(date?.startDate) : null,
        endDate: date?.endDate ? dateFormatStartFun(date?.endDate) : null,
        publisher_id: publisher?._id ? publisher?._id : null,
      })
    );
    setSnack(true);
  };

  const handleChange = (event) => {
    setPublisher(event.target.value);
    const pubData = dispatch(
      publisherUserAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: date?.startDate ? dateFormatStartFun(date?.startDate) : null,
        endDate: date?.endDate ? dateFormatStartFun(date?.endDate) : null,
        publisher_id: event.target.value?._id ? event.target.value?._id : null,
        userId: userId ? userId : null,
      })
    );
    setSnack(true);
  };

  useEffect(() => {
    dispatch(getPublisherAction());
    // setSnack(true);
  }, []);

  //   useEffect
  useEffect(() => {
    dispatch(
      publisherUserAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: date?.startDate ? dateFormatStartFun(date?.startDate) : null,
        endDate: date?.endDate ? dateFormatStartFun(date?.endDate) : null,
        publisher_id: publisher?._id ? publisher?._id : null,
        userId: userId ? userId : null,
      })
    );
  }, [pageState.page, pageState.pageSize]);

  return (
    <>
      <Helmet>
        <title>Real Opinion | Publisher-User-detail</title>
      </Helmet>
      <Appbar breadcrumb={breadcrumb} />
      <DrawerUI />
      <Body>
        <Stack sx={{ mb: 2 , display: "flex", justifyContent: "flex-end"}}>
          <Stack
            direction="row"
            spacing={2}
            sx={{ mb: 2, display: "flex", justifyContent: "flex-end" }}
            alignItems="center"
          >
            <Button
              variant="contained"
              onClick={() => {
                navigate("/user-widthdraw-transaction");
              }}
            >
              Widthdraw Transactions
            </Button>
          </Stack>

          <Stack
            direction="row"
            spacing={2}
            sx={{ mb: 2, display: "flex", justifyContent: "flex-end" }}
            alignItems="center"
          >
            <Button
              variant="contained"
              onClick={() => {
                navigate("/user-profiler-data");
              }}
            >
              Profiler Info
            </Button>
          </Stack>
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Stack direction="row" spacing={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Min Data/Time"
                value={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) => {
                  setDate({ ...date, startDate: newValue });
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Max Data/Time"
                value={date?.endDate}
                minDate={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) => {
                  setDate({ ...date, endDate: newValue });
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            {date?.startDate && date?.endDate && (
              <Button variant="contained" onClick={dateWiseUser}>
                find data
              </Button>
            )}
          </Stack>

          <Stack
            sx={{ mt: 1 }}
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Stack direction={"row"} justifyContent={"space-between"}>
              <Paper
                component="form"
                sx={{
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  width: 300,
                  backgroundColor: "transparent",
                }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="search By Emails,UserId"
                  inputProps={{
                    "aria-label": "search By Emails And UserId",
                  }}
                  onChange={(e) => setUserId(e.target.value)}
                />
                <IconButton
                  type="button"
                  sx={{ p: "10px" }}
                  aria-label="search"
                >
                  <SearchIcon onClick={searchHandler} />
                </IconButton>
              </Paper>
            </Stack>
          </Stack>

          <Stack direction="row">
            <Box sx={{ minWidth: 150 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Publisher</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={publisher?.name} // ✅ Correct binding
                  label="Publisher"
                  onChange={handleChange} // ✅ Fixes event handling
                >
                  {publiserData?.map((item, i) => (
                    <MenuItem key={i} value={item}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Stack>
        </Stack>

        <Card sx={{ mt: 2 }}>
          <TableContainer sx={{ width: "100%" }}>
            <Stack
              direction={"row"}
              justifyContent="space-between"
              alignItems={"center"}
            >
              <Typography sx={{ ml: 3, my: 2 }} variant="h6">
                Publisher Users
              </Typography>
              {/* <IconButton sx={{ mr: 3, my: 2 }} onClick={handleRefresh}><CachedIcon /></IconButton> */}
            </Stack>

            <Paper
              sx={{
                bgcolor: "#fff",
                "& .super-app-theme--header": {
                  bgcolor: "#071D45",
                  color: "#fff",
                },
              }}
              elevation={0}
            >
              <DataGrid
                className={classes.root}
                getRowHeight={() => "auto"}
                sx={{ border: 0 }}
                autoHeight
                rows={userDetailsData}
                columns={missionDetailsColumn}
                getRowId={(row) => row._id}
                disableSelectionOnClick
                experimentalFeatures={{ newEditingApi: true }}
                pagination
                // pageSize={pageSize}
                // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[25, 50, 100]}
                disableColumnSelector
                loading={usersDetailsLoading ? <LoadingUI /> : false}
                components={{
                  NoRowsOverlay: () => <NoDataFound />,
                  // Toolbar: GridToolbar,
                }}
                rowCount={totalCount}
                paginationModel={setPageState}
                page={pageState.page}
                pageSize={pageState.pageSize}
                paginationMode="server"
                onPageChange={(newPage) => {
                  setPageState((old) => ({ ...old, page: newPage }));
                }}
                onPageSizeChange={(newPageSize) =>
                  setPageState((old) => ({ ...old, pageSize: newPageSize }))
                }
              />
            </Paper>
          </TableContainer>
        </Card>
      </Body>

      <SnackBarUI
        state={snack}
        setState={setSnack}
        status={status}
        message={message}
      />

      {widthdrawPauseStatus && (
        <SnackBarUI
          state={snack1}
          setState={setSnack1}
          status={widthdrawPauseStatus}
          message={widthdrawPauseMsg}
        />
      )}
    </>
  );
};

export default PublisherUser;
